import queryString from 'query-string';

// Interceptors
import { VirtualCredentialApiInstance } from './../interceptors/virtual-credential.interceptor';

// Constants
import { APP_CONFIG } from '../constants';

// Helpers
import { errorHandler } from '../helpers';

export const VirtualCredentialService = {

    /**
     * Obtiene un listado de transacciones
     * @param {Object} params Parámetros de la url
     * @param {Object} pagination Objeto paginador
     */
    list: async (params, pagination) => {

        if (pagination) {

            params['size'] = pagination.size;
        }

        try {

            const url = `${APP_CONFIG.API.VIRTUAL_CREDENTIAL.HISTORY}?${queryString.stringify(params)}`;
            const resp = await VirtualCredentialApiInstance.get(url);
            const { data, metadata } = resp;

            return {
                data: data.filter(t => !Object.keys(APP_CONFIG.API.VIRTUAL_CREDENTIAL.INVALID_CODE).map(code => Number(code)).includes(t.transactionStatus)),
                metadata: {

                    page: pagination.page,
                    size: metadata.size,
                    nextKey: metadata.nextKey
                }
            };

        } catch (error) {

            throw error;
        }
    },

    /**
     * Obtiene una transacción por su id
     * @param {string} id Identificador de la transacción
     */
    get: async (id) => {

        try {

            const url = `${APP_CONFIG.API.VIRTUAL_CREDENTIAL.TRANSACTION}/${id}`;
            const resp = await VirtualCredentialApiInstance.get(url);
            const { data } = resp;

            return {
                ...data
            };

        } catch (error) {

            throw error;
        }
    },

    /**
     * Crea una transacción
     * @param { Object } transaction Transacción para crear 
     */
    create: async (transaction) => {

        try {

            const url = `${APP_CONFIG.API.VIRTUAL_CREDENTIAL.TRANSACTION}`;
            const resp = await VirtualCredentialApiInstance.post(url, transaction);
            const { data } = resp;
            
            return {
                ...data
            };

        } catch (error) {
            window?.DD_LOGS?.logger && window.DD_LOGS.logger.error({error});
            throw errorHandler(error, 'VIRTUAL_CREDENTIAL');
        }
    },

    /**
     * Actualiza una transacción
     * @param { string } id Identificador de la transacción a actualizar
     * @param { Object } transaction Datos de la transacción para actualizar
     */
    update: async (id, transaction) => {

        try {

            const body = {

                transactionStatus: transaction.transactionStatus,
                amount: transaction.amount,
                discountAmount: transaction.discountAmount
            };

            const url = `${APP_CONFIG.API.VIRTUAL_CREDENTIAL.TRANSACTION}/${id}`;
            const resp = await VirtualCredentialApiInstance.patch(url, body);
            const { data } = resp;

            return {
                ...data
            };

        } catch (error) {

            throw error;
        }
    },

    /**
     * Envia un mail de contacto
     * @param { Object } message Datos del mensaje a ser enviado
     */
    sendCommentary: (message) => {

        return new Promise(async (resolve, reject) => {
            try {

                if (message?.name === '') {

                    delete message['name'];
                }

                const body = {

                    ...message
                };

                const url = APP_CONFIG.API.VIRTUAL_CREDENTIAL.CONTACT;
                await VirtualCredentialApiInstance.post(url, body);
                resolve({
                    ok: true
                });

            } catch (error) {

                reject({
                    error: {
                        status: error.status,
                        message: error.message
                    }
                })
            }
        })
    },

    /**
     * Obtiene un listado de beneficios disponibles
     * @param {Object} params Parámetros de la url
     * @param {Object} pagination Objeto paginador
     */
    listBenefit: async (params, pagination) => {

        if (pagination) {

            params['size'] = pagination.size;
            params['page'] = pagination.page;
        }

        try {

            const url = `${APP_CONFIG.API.VIRTUAL_CREDENTIAL.BENEFITS}?${queryString.stringify(params)}`;
            const resp = await VirtualCredentialApiInstance.get(url);
            const { data } = resp;
            return data;
        } catch (error) {
            window?.DD_LOGS?.logger && window.DD_LOGS.logger.error({error});
            throw error;
        }
    },

    /**
     * Obtiene las configuraciones para la app (GONOGO)
     */
    getSettings: async () => {

        try {

            const url = `${APP_CONFIG.API.VIRTUAL_CREDENTIAL.SETTINGS}`;
            const resp = await VirtualCredentialApiInstance.get(url);
            const { data } = resp;

            return {
                ...data
            };

        } catch (error) {

            throw error;
        }
    },

    /**
     * Obtiene la metadata de las transacciones para mostar en la Home
     */
     getTransactionMetadata: async () => {

        try {
            
            const url = `${APP_CONFIG.API.VIRTUAL_CREDENTIAL.METADATA}/?transactionStatus=${APP_CONFIG.API.VIRTUAL_CREDENTIAL.TRANSACTION_METADATA}`;
            const resp = await VirtualCredentialApiInstance.get(url);
            const respFiles = await VirtualCredentialService.getFilesOfTransactions();
            const { data } = resp;

            return {
                data: {
                    ...data
                },
                files: respFiles
            };

        } catch (error) {

            throw error;
        }
    },

    /**
     * Obtiene los archivos de transacciones
     */
    getFilesOfTransactions: async () => {

        try {

            const url = `${APP_CONFIG.API.VIRTUAL_CREDENTIAL.FILES}`;
            const resp = await VirtualCredentialApiInstance.get(url);
            const { data } = resp;

            return data;

        } catch (error) {

            throw error;
        }
    },
};